module.exports = __webpack_public_path__ + "media/images/ln/horoscope_2-014839f09658af462a2fa6ec35010637.png";